import { useEffect, type ReactNode } from 'react'
import { SidebarProvider, useSidebar } from '@/components/ui/sidebar'
import { ConversationSidebar } from '@/components/ConversationSidebar'

// Wrapper to access ConversationSidebar context
function ConversationSidebarWithRef({
  chatComponent,
  openRef,
}: {
  chatComponent: ReactNode
  openRef: React.MutableRefObject<(open: boolean) => void>
}) {
  const { setOpenMobile } = useSidebar()

  useEffect(() => {
    openRef.current = setOpenMobile
  }, [setOpenMobile, openRef])

  return <ConversationSidebar chatComponent={chatComponent} />
}

function RightSidebarSync({
  mobileOpen,
  onMobileChange,
}: {
  mobileOpen: boolean
  onMobileChange: (open: boolean) => void
}) {
  const { setOpenMobile, openMobile, isMobile } = useSidebar()

  // Sync mobile state from parent to sidebar context
  useEffect(() => {
    if (isMobile) {
      setOpenMobile(mobileOpen)
    }
  }, [mobileOpen, isMobile, setOpenMobile])

  // Sync mobile state changes back to parent
  useEffect(() => {
    if (isMobile) {
      onMobileChange(openMobile)
    }
  }, [openMobile, isMobile, onMobileChange])

  return null
}

export function ChatSidebarHost({
  chatComponent,
  openRef,
  mobileOpen,
  onMobileChange,
  open,
  onOpenChange,
}: {
  chatComponent: ReactNode
  openRef: React.MutableRefObject<(open: boolean) => void>
  mobileOpen: boolean
  onMobileChange: (open: boolean) => void
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <SidebarProvider open={open} onOpenChange={onOpenChange}>
      <RightSidebarSync
        mobileOpen={mobileOpen}
        onMobileChange={onMobileChange}
      />

      <ConversationSidebarWithRef
        chatComponent={chatComponent}
        openRef={openRef}
      />
    </SidebarProvider>
  )
}
